import { render, staticRenderFns } from "./CertificateDialog.vue?vue&type=template&id=615a5968&scoped=true"
import script from "./CertificateDialog.vue?vue&type=script&lang=js"
export * from "./CertificateDialog.vue?vue&type=script&lang=js"
import style0 from "./CertificateDialog.vue?vue&type=style&index=0&id=615a5968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a5968",
  null
  
)

export default component.exports